(function () {
	'use strict';
	angular.module('app.leanProjects') 
		.service('enterMetricDataService', enterMetricDataService); 

	enterMetricDataService.$inject = ['$http', '$filter', 'leanFilterService'];

	function enterMetricDataService($http, $filter, leanFilterService) {
		var urlPfx = '/api/2/factndx/{0}/';
		return {
			getMetricEntries: getMetricEntries,
			updateMetricEntries: updateMetricEntries
		};

		function getMetricEntries(date) {
			if (date !== undefined) {
				var url = String.format(urlPfx, leanFilterService.getFactoryList()) + 'MetricEntries?';
				var filterQueryParams = leanFilterService.getQueryParam(true);
				for (var i = 0; i < filterQueryParams.length; i++) {
					url = appendQueryParam(url, filterQueryParams[i].key, filterQueryParams[i].value);
				}
				url = appendQueryParam(url, 'date', getUtcOffsetDate(date));
				return $http.get(url)
					.then(getMetricEntriesComplete)
					.catch(getMetricEntriesFailed);
			}

			function getMetricEntriesComplete(response) {
				return response.data;
			}

			function getMetricEntriesFailed(error) {
				return error;
			}
		}

		function updateMetricEntries(metricEntries, date) {
			if (date !== undefined) {
				var url = String.format(urlPfx, leanFilterService.getFactoryList()) + 'MetricEntries?';
				url = appendQueryParam(url, 'date', $filter('date')(getUtcOffsetDate(date), 'yyyy-MM-dd'));
				return $http.put(url, metricEntries)
					.then(updateMetricEntriesComplete)
					.catch(updateMetricEntriesFailed);
			}

			function updateMetricEntriesComplete(response) {
				return response.data;
			}

			function updateMetricEntriesFailed(error) {
				return error;
			}
		}

		function getUtcOffsetDate(date) {
			if (date) {
				var localDate = moment(date).subtract(date.getTimezoneOffset(), 'minutes');
				return $filter('date')(localDate._d, 'yyyy-MM-dd', 'UTC');
			} 
			return date;
		}
	}
})();
